import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import ServicesItem from "../components/TripsItem";
import Helmet from "../components/Helmet";
import CommonSection from "../components/CommonSection";
import Chat from "../components/chat";
import CustomerDetails from "../components/CutomerTripDetails";
import { useLocation, useParams } from "react-router-dom";

const TripDetails = (props) => {
  const [activeTab, setActiveTab] = useState("Details");
  const [detailData, setDetailData] = useState();

  useEffect(() => {
    const urlSearchString = window.location.search;

    const params = new URLSearchParams(urlSearchString);

    const myObjectParam = params.get("myObject");
    const myObjectData = JSON.parse(decodeURIComponent(myObjectParam));
    console.log("params", myObjectData);
    setDetailData(myObjectData);
  }, []);

  return (
    <Helmet title="Services">
      <section className="pt-0">
        <CommonSection title="Trip Details" />
        <Container>
          <Row>
            <Col lg="12" md="10" className="m-auto">
              {/* <h4 className="d-flex align-items-center gap-2 justify-content-center mb-5">
                <i class="ri-key-2-line"></i> Sign Up
              </h4> */}
              <div className=" mb-5 time__line d-flex align-items-center justify-content-between">
                <h6
                  className={` ${
                    activeTab === "Details" ? "active2" : ""
                  }  line`}
                  onClick={() => setActiveTab("Details")}
                >
                  <span
                    className={` ${activeTab === "Details" ? "active" : ""}  `}
                    onClick={() => setActiveTab("Details")}
                  >
                    1
                  </span>{" "}
                  Details
                </h6>

                <h6
                  className={` ${activeTab === "messages" ? "active2" : ""}  `}
                  onClick={() => setActiveTab("messages")}
                >
                  <span
                    className={` ${
                      activeTab === "messages" ? "active" : ""
                    } me-1 `}
                    onClick={() => setActiveTab("messages")}
                  >
                    2
                  </span>
                  Messages
                </h6>
                <h6
                  className={` ${activeTab === "help" ? "active2" : ""}  `}
                  onClick={() => setActiveTab("help")}
                >
                  <span
                    className={` ${activeTab === "help" ? "active" : ""} me-1 `}
                    onClick={() => setActiveTab("help")}
                  >
                    3
                  </span>
                  Help
                </h6>
              </div>
              {activeTab === "Details" ? (
                <CustomerDetails data={detailData} />
              ) : null}
              {activeTab === "messages" ? <Chat /> : null}
              {activeTab === "help" ? <div>ddd</div> : null}
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default TripDetails;
